<template>
	<input v-model="text" :type="type" :min="min" :max="max" :step="step" :class="`${full ? 'grow' : ''} input-like`" @change="updateValue">
</template>
<script setup lang="ts">
import {ref} from 'vue'

const props = defineProps<{
	type:string,
	value:number|string|null,
	min?:number|string,
	max?:number|string,
	step?:number,
	maxlength?:number,
	full?:boolean,
}>()

const text = ref(props.value)

const emit = defineEmits([
	'update:value',
])

function updateValue(): void{
	emit('update:value', text.value)
}
</script>
